import { push } from 'connected-react-router';
import { all, fork, put, select, spawn, take } from 'redux-saga/effects';
import {
  ACCOUNT_DETAILS_FAILURE,
  ACCOUNT_DETAILS_SUCCESS,
  accountDetailsRequest
} from '../../modules/account/actions';
import { isOmniLinked } from '../../modules/account/selectors';
import { getPathname } from '../../modules/app/selectors';
import { isAuthenticated } from '../../modules/user/selectors';
import { HOME } from '../../routes/paths';
import * as form from '../FormMessage/actions';
import i18n from '../i18n/i18n';
import { getLocale } from '../i18n/selectors';
import { VIEW_ENTER } from './actions';

/* eslint-disable no-constant-condition */
export function* watchAccountIsNotLinked() {
  yield take([ACCOUNT_DETAILS_SUCCESS, ACCOUNT_DETAILS_FAILURE]);
  const currentPage = yield select(getPathname);
  const authenticated = yield select(isAuthenticated);
  const omniLinked = yield select(isOmniLinked);
  if (currentPage !== HOME && (!authenticated || !omniLinked)) {
    yield put(push(HOME));
  }
}

export function* watchViewEnter() {
  while (yield take(VIEW_ENTER)) {
    const authenticated = yield select(isAuthenticated);
    if (authenticated) {
      yield fork(watchAccountIsNotLinked);
      yield put(accountDetailsRequest());
    } else {
      const locale = yield select(getLocale);
      yield put(push(HOME));
      yield put(form.setMessage(form.ERROR, i18n('common', 'notAuthenticated', locale)));
    }
  }
}

export default function* root() {
  yield all([
    spawn(watchViewEnter)
  ]);
}
/* eslint-enable no-constant-condition */
